import { VIEWS_MAP } from '../router/constants';

export const POSSIBLE_ACTIVE_FLOWS = ['invoice_stripe', 'gusto'];

export const ACTIVE_FLOW_REDIRECT_MAP = {
  invoice_stripe: `/${VIEWS_MAP.INVOICES.replace(':initialStep?', 'payment-options')}`,
  gusto: `/${VIEWS_MAP.APP_CENTER_INSTRUCTIONS.replace(':vendorId', '15')}`,
};
